export default "/images/years_icon.svg?a8940366090662aac6582674b74716bb";